export default __webpack_public_path__ + "static/media/ExtrusionPrinterImg.02a25dd7.jpg";